// extracted by mini-css-extract-plugin
export default {"root":"Back_root__SvSco"};